
import { MdError } from "react-icons/md";
import DefaultButton from "../buttons/defaultButton";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { Tooltip } from "flowbite-react";

const DefaultInput = ({
  id,
  label,
  type,
  placeholder,
  min = "",
  max = "",
  required,
  name,
  value,
  labelClass,
  classnames = "",
  ClassNamess = "",
  onChange,
  onBlur,
  error,
  readOnly = false,
  rightIcon = null,
  leftIcon = null,
  iconBtn = false,
  iconBtnClick = () => null,
  limit = null,
  info = "",
  number = false,
  disabledIconBtn = false,
  isHidden = false,
  customLabel = false
}) => {
  return (
    <div className={`flex flex-col gap-1.5 relative w-full ${customLabel ? "pt-2": "pt-0"} ${ClassNamess} `}>
      {label && (
        <div className={`${isHidden ? "hidden" : "block"}`}>
          <label
            className={`${readOnly? "text-primary-600" :"text-gray-700"} font-medium text-sm flex items-center ${labelClass} ${customLabel ? "absolute -top-2 bg-white rounded-md left-2 !text-[10px] z-20 px-1" :""}`}
            htmlFor={id}
          >
            <span className="flex items-center gap-[2px]">
              {label}
              {info ?
                <div className="cursor-pointer text-gray-400 hover:text-gray-600 transition-colors">
                  <Tooltip content={info}>
                    <IoIosInformationCircleOutline />
                  </Tooltip>
                </div> : null}
            </span>
            {required ? <span className={"text-red-500 ml-0.5"}>*</span> : ""}
          </label>
        </div>
      )}
      <div className={`flex flex-col relative`}>
        <div className={`flex items-center gap-2 relative`}>
          {leftIcon ? (
            <div className="absolute left-0 top-0 h-10 w-10 border-0 flex items-center justify-center text-gray-400 z-10">
              {leftIcon}
            </div>
          ) : null}
          <input
            id={id}
            type={type ? type : "text"}
            placeholder={placeholder ? placeholder : `Enter ${label}`}
            name={name}
            onChange={(e) => {
              const value = e.target.value;
              if (limit && value.length > limit) {
                return;
              }
              onChange(e)
            }}
            min={min}
            max={max}
            onBlur={onBlur}
            value={value}
            pattern={number ? "[0-9]*" : undefined}
            onInput={(e) => {
              if (number) {
                e.target.value = e.target.value.replace(/\D/g, "");
              }
            }}
            readOnly={readOnly}
            className={`flex-1 ring-0 text-sm h-10 rounded-lg border border-gray-200 bg-white
                 placeholder:text-gray-400 text-gray-800
                 transition-all duration-200
                 focus:ring-2 focus:ring-primary-100 focus:border-primary-400 focus:shadow-none
                 hover:border-gray-300
                 ${readOnly ? "text-gray-400 bg-gray-50 cursor-default" : ""}
                 ${classnames} ${rightIcon ? "pr-12" : ""} ${leftIcon ? "pl-12" : ""} ${isHidden ? "hidden" : ""}
                 ${error ? "bg-red-50 border-red-300 focus:ring-red-100 focus:border-red-400" : ""
              }`}
          />

          {rightIcon ? (
            <div className="w-10 h-10 absolute right-0 top-0 flex items-center justify-center text-md text-gray-400 border-0">
              {rightIcon}
            </div>
          ) : (
            ""
          )}

          {iconBtn ? (
            <div>
              <DefaultButton
                onClick={iconBtnClick}
                size="icon"
                variant="secondary"
                name={iconBtn}
                disabled={disabledIconBtn}
              />
            </div>
          ) : null}
        </div>

        {error ? (
          <span className="flex items-center gap-1 text-xs text-red-500 mt-1">
            <MdError className="text-sm flex-shrink-0" />
            <p>{error}</p>
          </span>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default DefaultInput;
